import { isHavingProps } from '~/ZenOne-StoryBook/helpers/object'

export default {
  computed: {
    freeGood() {
      return (
        this?.item?.freeGood ||
        this?.product?.freeGood ||
        this?.productDistributor?.freeGood ||
        {}
      )
    },
    showFreeGoodInfo() {
      const { freeGood = {} } = this
      return freeGood !== null && isHavingProps(freeGood)
    },
  },
}
